module.exports = __webpack_public_path__ + "static/media/ClientCommunication4.ad2a8f8a.png";